import React from "react";
import { Modal, Form, Input, Row, Col, Card, Button, ColorPicker, Switch } from "antd";
import { ModeleService } from "../../services/ModeleService";
import Toast from "../../helpers/Toast";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { catchError } from "../../services/DaoService";
import CustomFormItem from "../utils/form/CustomFormItem";
import style from "./ModeleCreateForm.module.scss";

const ModeleCreateForm = ({ visible, onCreate, onCancel }) => {
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const [creating, setCreating] = React.useState(false);
	const [validationErrors, setValidationErrors] = React.useState({});

	const handleSave = (isRedirection) => {
		// setCreating(true);
		form
			.validateFields()
			.then((values) => {
				let nvalues = { ...values };
				if (values.couleur) {
					nvalues = { ...values, couleur: "#" + values.couleur.toHex() };
				}
				ModeleService.getInstance()
					.create(nvalues)
					.then((response) => {
						Toast.success(response.message);
						form.resetFields();
						onCreate(response.data);
						if (isRedirection) {
							navigate(`/modele/${response.data.uid}`);
						}
					})
					.catch((error) => {
						const errors = error.response.data;
						if (errors.validation && Object.keys(errors?.errors).length) {
							setValidationErrors(errors.errors);
						} else {
							catchError(error);
						}
					})
					.finally(() => {
						setCreating(false);
					});
			})
			.catch(() => {
				setCreating(false);
			});
	};

	return (
		<Modal
			width={"50%"}
			open={visible}
			onCancel={onCancel}
			title='Créer un nouveau type de dossier'
			footer={[
				<>
					<Row gutter={24}>
						<Col>
							<Button
								key='cancel'
								onClick={onCancel}
								className={style.ButtonNew}
							>
								Annuler
							</Button>
						</Col>
						<Col>
							<Button
								key='save-show'
								type='primary'
								loading={creating}
								onClick={() => handleSave(true)}
								className={style.ButtonNew}
							>
								Enregistrer et Afficher
							</Button>
						</Col>
						<Col>
							<Button
								key='save-again'
								type='primary'
								loading={creating}
								onClick={() => handleSave(false)}
								className={style.ButtonNew}
							>
								Enregistrer et Créer
							</Button>
						</Col>
					</Row>
				</>,
			]}
		>
			<Card style={{ marginBottom: 5 }}>
				<Form
					layout='vertical'
					form={form}
					name='createModeleForm'
					initialValues={{
						enabled: 1,
					}}
				>
					<Row gutter={24}>
						<Col xs={24} md={24} lg={12}>
							<CustomFormItem
								label='Nom'
								name='nom'
								rules={[{ required: true, message: "Veuillez saisir le nom!" }]}
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
							>
								<Input type='text' />
							</CustomFormItem>
						</Col>
						<Col xs={24} md={24} lg={12}>
							<CustomFormItem
								label='Code'
								name='code'
								rules={[
									{ required: true, message: "Veuillez saisir le code!" },
									{ max: 3, message: "Le code doit avoir 3 caractères!" },
									{ min: 3, message: "Le code doit avoir 3 caractères!" },
								]}
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
							>
								<Input type='text' />
							</CustomFormItem>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col xs={24} md={24} lg={24}>
							<CustomFormItem
								label='Description'
								name='description'
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
							>
								<Input.TextArea rows={4} />
							</CustomFormItem>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col xs={24} md={12} lg={12}>
							<CustomFormItem
								label='Couleur'
								name='couleur' rules={[{ required: true, message: "Veuillez choisir une couleur !" }]}
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
							>
								<ColorPicker format='hex' />
							</CustomFormItem>
						</Col>
						<Col xs={24} md={12} lg={12}>
							<CustomFormItem
								label="Default" 
								name="default" valuePropName='checked'
								validationErrors={validationErrors}
								setValidationErrors={setValidationErrors}
							>
								<Switch />
							</CustomFormItem>
						</Col>
					</Row>
				</Form>
			</Card>
		</Modal>
	);
};

export default ModeleCreateForm;

ModeleCreateForm.propTypes = {
	visible: PropTypes.bool,
	onCreate: PropTypes.func,
	onCancel: PropTypes.func,
};
